import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { TextsContext } from "context/textsContext";
import { useMyFavoritePlanForm } from "context/MyFavoritePlanFormContext";
import { buildFavPlanPath, getApplicableFavPlanSteps, FAV_PLAN_FIRST_STEP_SLUG } from "constants/myFavoritePlanForm";
import { convertMoneyAndTruncateOrRound } from "components/utils/helper";
import { TitleH1Component } from "components/TitleH1Component";
import { TitleH2Component } from "components/TitleH2Component";
import { CalculationErrorBadge } from "components/CalculationErrorBadge";
import StyleFooter from "scss/footer.module.scss";
import StyleBtn from "scss/btn.module.scss";

const FavoritePlanFooterComponent = () => {
    const { texts } = useContext(TextsContext);
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const { favoritePlanFormState, validateBaseInformation, validateStep, goToDashboard, favoritePlanId, isFemale } = useMyFavoritePlanForm();

    const totalPremiumWithFee = +favoritePlanFormState?.calculation?.data?.quotation?.totalPremiumWithFee || 0;
    const calculationError = favoritePlanFormState?.calculationError;

    // Se navega sobre esta lista filtrada (no la lista completa de steps) para que
    // Next/Previous salten el rider de maternidad cuando el usuario no es elegible,
    // igual que el cotizador salta su propio /step6 en useSteps.jsx.
    const applicableSteps = getApplicableFavPlanSteps(isFemale());
    const currentIndex = applicableSteps.findIndex(step => pathname.endsWith(`/${step.slug}`));

    const backUrl = () => {
        if (currentIndex === 0) {
            goToDashboard();
        } else  {
            navigate(buildFavPlanPath(applicableSteps[currentIndex - 1].slug, favoritePlanId));
        }
    };

    const nextUrl = () => {
        if (pathname.endsWith(`/${FAV_PLAN_FIRST_STEP_SLUG}`) && validateBaseInformation()) {
            return;
        }

        if (validateStep(pathname)) {
            return;
        }

        if (currentIndex < applicableSteps.length - 1) {
            navigate(buildFavPlanPath(applicableSteps[currentIndex + 1].slug, favoritePlanId));
        }
    };

    return (
        <footer className={StyleFooter.footer}>
            <div className={`${StyleFooter.colfootercontent} d-flex flex-md-column justify-content-between align-items-center`}>
                <TitleH2Component styleGroup={`raleway fw_400 lh_20 color_primary_2 mb-0 me-2 ${StyleFooter.cost}`}>
                    {texts?.footer_title ?? 'Estimated annual cost:'}
                </TitleH2Component>
                <TitleH1Component styleGroup="raleway_semibold fw_600 lh_40 color_secundary spacin_2 mb-0">
                    {convertMoneyAndTruncateOrRound(totalPremiumWithFee.toFixed(2))}
                </TitleH1Component>
                {calculationError && <CalculationErrorBadge />}
            </div>

            <div className={`${StyleFooter.colfooterbtn}`}>
                <div className={`d-flex justify-content-md-end justify-content-evenly my-2 my-md-0 my-lg-auto me-0 me-lg-5 ${StyleBtn.btnLine}`}>
                    <button type="button" onClick={backUrl} className={`Poppins fw_500 color_secundary border-0 me-md-1 me-4 ${StyleBtn.btnNeutro} ${StyleBtn.wpbtn}`}>
                        {texts?.footer_button_previous ?? 'Previous'}
                    </button>
                    <button type="button" onClick={nextUrl} className={`Poppins fw_500 color_primary ms-1 ${StyleBtn.btn} ${StyleBtn.wpbtn}`}>
                        {texts?.footer_button_next ?? 'Next'}
                    </button>
                </div>
            </div>
        </footer>
    );
};

export default FavoritePlanFooterComponent;
